import React from 'react';
import { useParams } from 'react-router-dom';

import SleepioEmailCallback from './SleepioEmailCallback';
import SparkEmailCallback from './SparkEmailCallback';

import { Product } from '@/utils/productHelpers';

const EmailAuthCallback: React.FC = () => {
  const { product } = useParams<{ product: Product }>();

  if (product === 'sleepio') {
    return <SleepioEmailCallback />;
  }
  return <SparkEmailCallback />;
};

export default EmailAuthCallback;
